import { Component, OnInit, ChangeDetectorRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Model_Datasource, AbsPaginatedGrid, SOURCE_COLONNE, AbwDatasourceParams, TYPE_DATASOURCE, TYPE_COLONNE, TYPE_DONNEE } from 'src/app/app.models';
import { AbwDatatableComponent } from 'src/app/shared/abw-datatable/abw-datatable.component';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';
import { ABWToastService } from 'src/app/shared/helpers/abw-toast.service';

@Component({
    selector: 'app-datasource-designer-edit-datas-modal',
    templateUrl: './datasource-designer-edit-datas-modal.component.html',
    styleUrls: ['./datasource-designer-edit-datas-modal.component.scss']
})
export class DatasourceDesignerEditDatasModal implements OnInit {
    errString: string = null;
    loading = false;
    datasource: Model_Datasource;
    absGrid = new AbsPaginatedGrid();
    @ViewChild('datatable') datatable: AbwDatatableComponent;

    constructor(
        private _formBuilder: FormBuilder,
        private _cdf: ChangeDetectorRef,
        private _toastrService: ABWToastService,
        public _datasourceService: DatasourceService,
        public dialogRef: MatDialogRef<DatasourceDesignerEditDatasModal>,
        @Inject(MAT_DIALOG_DATA) public data: { datasource: Model_Datasource },
    ) {
        this.datasource = data.datasource;
    }

    ngOnInit() {
        const absColumns = this.datasource.DS_PARAMS.DS_COLUMNS.filter(c => c.sourceColumn == SOURCE_COLONNE.DATASOURCE).map(c => ({ 
            mDatasource: c.name, 
            mTitle: c.label || c.name,
            mType: TYPE_COLONNE.DIMENSION,
            mTypeDonnees: TYPE_DONNEE.STRING,
            mVisible: true,
            mHasCustomHtml: false 
        }));
        const absColumnsNames = absColumns.map(c => c.mDatasource);
        const datas = this.datasource.DS_PARAMS.datas;

        this.absGrid = {
            mAbsColumns: absColumns,
            mColumnNames: absColumnsNames,
            mColumns: absColumnsNames,
            mPagination: {
                mDatas: datas,
                mCountTotal: datas.length,
                mPageSize: datas.length,
                mPageNumber: 1,
                mTotalPages: 1,
            },
            mTotalDatas: datas.length
        };
    }

    onPasteExcelDatas(event: ClipboardEvent) {
        const clipboardData = event.clipboardData;
        const pastedText = clipboardData.getData('text');
        const row_data = pastedText.split('\n');
        const data=[];
        row_data.filter(row => !!row).forEach(row => {
            row = row.replace('\r', '');
            const item = {};
            this.datatable.datas.mColumnNames.forEach((a, index) => { item[a] = row.split('\t')[index]; });
            data.push(item);
        });
        this.datatable.datas.mPagination.mDatas = [...data];
        this.datatable.refresh();
    }

    dismiss() {
        return this.dialogRef.close();
    }

    doSaveDatasourceAction() {
        this.loading = true;
        this.errString = null;
        if (!this.datasource.DS_PARAMS) { this.datasource.DS_PARAMS = new AbwDatasourceParams(); }
        if (this.datasource.TYPE_DATASOURCE == TYPE_DATASOURCE.STATIC) { 
            this.datasource.DS_PARAMS.datas = this.datatable.datas.mPagination.mDatas; 
        }
        this._datasourceService.doSaveDatasourceAction(this.datasource).subscribe(_datasourceSaved => {
            this.loading = false;
            this._toastrService.showToast('La source de données a été enregistrée.', 'Abworkflow');
            this.dialogRef.close(this.datasource);
        }, (error: string) => {
            //this._toastrService.showToast(error);
            this.loading = false;
            this.errString = error;
        })
    }
}